import React, { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import MaterialSelect from '@material-ui/core/Select';
import MaterialFormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import classnames from 'classnames';
import styles from './styles.module.scss';

const Select = forwardRef(
    (
        {
            helperText,
            value,
            defaultValue,
            children,
            placeholder,
            options,
            onChange,
            className,
            ...props
        },
        ref
    ) => {
        // just a quick "uniqueId" hack for placeholderId it's not a longterm solution here.
        // ideally, it should be some sort of uuid.
        const [placeholderId] = useState('__undefined__');
        const values = {
            value: !value && placeholder ? placeholderId : value,
            defaultValue:
                !defaultValue && !value && placeholder
                    ? placeholderId
                    : defaultValue
        };
        const attrs = {
            ...values,
            ref,
            className: classnames(styles.root, className, {
                [styles.placeholder]:
                    [values.value, values.defaultValue].indexOf(placeholderId) >
                    -1
            })
        };

        function onChangeFn(event, child) {
            const eventClone = { ...event };

            if (eventClone.target.value === placeholderId) {
                eventClone.target = {
                    value: '',
                    name: event.target.name
                };
            }

            onChange(eventClone, child);
        }

        function showPlaceholder() {
            if (!placeholder) {
                return null;
            }

            // being disabled leaves it as a placeholder

            return (
                <MenuItem
                    value={placeholderId}
                    className="NeptuneDropdown-placeholder"
                >
                    {placeholder}
                </MenuItem>
            );
        }

        function makeOptions() {
            if (!options?.length) {
                return <MenuItem />;
            }

            return options.map(({ text, value: v, id }) => (
                <MenuItem key={id || v || text} value={v || id || text}>
                    {text || v || id}
                </MenuItem>
            ));
        }

        return (
            <MaterialFormControl fullWidth>
                <MaterialSelect
                    variant="outlined"
                    fullWidth
                    onChange={(event, child) => onChangeFn(event, child)}
                    {...props}
                    {...attrs}
                >
                    {showPlaceholder()}
                    {!children && makeOptions()}
                    {children}
                </MaterialSelect>
                {helperText && (
                    <FormHelperText variant="outlined" error={props.error}>
                        {helperText}
                    </FormHelperText>
                )}
            </MaterialFormControl>
        );
    }
);

Select.displayName = 'NeptuneDropdown';

Select.propTypes = {
    ...MaterialSelect.propTypes,
    options: PropTypes.instanceOf(Array),
    placeholder: PropTypes.string
};

Select.defaultProps = {
    ...MaterialSelect.defaultProps,
    options: null,
    placeholder: null
};

export default Select;
